import { EnrollmentClient } from '../shared/EnrollmentClient';
import { PARAM } from '../../../constants/reading/ApiConstants';
import { READING_APPLICATION_NAME } from '../../../constants/shared/CommonConstants';

const { APPLICATION_NAME, BURST_GROUP_UID } = PARAM;

class ReadingEnrollmentClient extends EnrollmentClient {
    getEnrollmentInfoParams = params => {
        const { burstGroupUid } = params;
        return [
            `${APPLICATION_NAME}: "${READING_APPLICATION_NAME}"`,
            ...this.getCommonEnrollmentInfoParams(params),
            ...(burstGroupUid ? [`${BURST_GROUP_UID}: "${burstGroupUid}"`] : []),
        ];
    };
}

export default new ReadingEnrollmentClient();
